import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { isEmpty } from 'radash';

import { Button } from '@/components/core/Button';
import { Icon } from '@/components/core/Icon';
import { useStepper } from '@/hooks/useStepper';
import { useToast } from '@/hooks/useToast';
import { useTranslation } from '@/hooks/useTranslation';
import { DataModelAttribute } from '@/types/DataModel';

const NavigationButtons = ({
    selectedAttributes,
    runMassUpdate,
    isButtonDisable,
}: {
    selectedAttributes: DataModelAttribute[];
    runMassUpdate: (data: object) => void;
    isButtonDisable: boolean;
}) => {
    const { currentStep, steps, nextStep, prevStep } = useStepper();
    const { t } = useTranslation();
    const { toast } = useToast();

    const onNextStep = () => {
        if (isEmpty(selectedAttributes)) {
            toast.warning(t('MASS_UPDATE_EDITOR.NO_ATTRIBUTES_SELECTED'));
        } else {
            nextStep();
        }
    };

    return (
        <div className="tw-flex tw-space-x-2">
            {currentStep > 1 && (
                <Button
                    disabled={isButtonDisable}
                    onClick={prevStep}
                    variant="secondary"
                    className="tw-bg-white"
                >
                    <span className="tw-flex tw-items-center">
                        <Icon
                            icon={ChevronLeftIcon}
                            size="sm"
                            variant="secondary"
                        />
                        <span className="tw-ml-2">{t('PREVIOUS')}</span>
                    </span>
                </Button>
            )}
            {!(currentStep === steps.length) && (
                <Button disabled={isButtonDisable} onClick={onNextStep} data-testid='next-btn'>
                    {t('NEXT')}
                </Button>
            )}
            {currentStep === steps.length && (
                <Button disabled={isButtonDisable} onClick={runMassUpdate} data-testid='run-mass-update-btn'>
                    {t('MASS_UPDATE_EDITOR.RUN')}
                </Button>
            )}
        </div>
    );
};

export default NavigationButtons;
